export default __webpack_public_path__ + "static/media/loading-spinner-transparent.739bf643.gif";